import { CartaCreditoFinanceiro } from './carta-credito-financeiro.model'
export class FaturamentoProdutoCreditoFinanceiro {

  id: number;
  cartaCredito: CartaCreditoFinanceiro;
  houveFaturamentoIncentivo: boolean;
  houveFaturamentoAcima: boolean
  trimestral: boolean;


  constructor(init?: Partial<FaturamentoProdutoCreditoFinanceiro>) {
    Object.assign(this, init);
  }
}
